import { FeatureStatus } from '@yourcause/common/feature-flag';

export interface FeatureFlag {
  feature: FeatureFlags;
  name: string;
  status: FeatureStatus;
  statusDate: string;
  updatedDate: string;
}

export enum FeatureFlags {
  TestFlag = 1,
  TestFlag2 = 2
}

export enum GC_Feature_Flags {
  AllowMultipleResponsesApplicantForms = 9,
  InvoiceInLocalCurrency = 10,
  TranslateApplicantResponses = 11,
  AdobeSignIntegration = 12,
  ApplicationSummaries = 13,
  CycleFundingCaps = 14
}
